import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { isAndroidWebView } from "./lib/platformDetect";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 2026-08-30 - Register the (shared FCM + PWA caching) service worker on every browser/PWA
// app boot, not only after login - Chrome's install criteria require an active SW with a
// fetch handler before it will offer/allow installation. pushNotifications.js registers this
// SAME file again post-login purely to obtain it for FCM token generation - registering the
// same URL twice is a safe no-op (the browser returns the existing registration). Skipped
// entirely inside the Android WebView - that native app never used this SW/token path before
// (it uses window.AndroidFCMBridge instead) and this must stay a pure ADDITION for browser/
// PWA users, never a new code path inside the existing WebView.
if ("serviceWorker" in navigator && !isAndroidWebView()) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/firebase-messaging-sw.js").catch(() => {});
  });
}
